import "./SectionHeader.css";

const SectionHeader = ({
  icon: Icon,
  iconElement,
  title,
  description,
  actions,
  align = "start",
  variant = "primary",
  size = "md",
  iconSize = 22,
  animation = "",
  className = "",
}) => {
  return (
    <div className={`ui-section-header ${align} ${variant} ${size} ${animation} ${className}`}>
      {(Icon || iconElement) && (
        <span className="ui-section-header-icon">
          {Icon ? <Icon size={iconSize} /> : iconElement}
        </span>
      )}

      <div className="ui-section-header-content">
        {title && <h2 className="ui-section-header-title">{title}</h2>}
        {description && (
          <p className="ui-section-header-description">{description}</p>
        )}
      </div>

      {actions && <div className="ui-section-header-actions">{actions}</div>}
    </div>
  );
};

export default SectionHeader;
